import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getMetadata, getMetaTags } from "../../util/metadata";

export default function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = getMetadata(pathname);
    document.title = meta.title;
    for (const [attribute, key, content] of getMetaTags(meta)) {
      let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attribute, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    }
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = meta.url;
  }, [pathname]);
  return null;
}
